import { cn } from "@/lib/utils";
import { Badge } from "../ui/badge";
import { formatCAD, sub } from "@/lib/money";
import { Cents } from "@/types/money.types";

type Variant = "default" | "lg";

type PriceWithDiscountProps = {
  priceCents: Cents;
  discountPriceCents?: Cents | null;
  variant?: Variant;
};

const PriceWithDiscount = ({
  priceCents,
  discountPriceCents,
  variant = "default",
}: PriceWithDiscountProps) => {
  const isDiscounted = discountPriceCents && discountPriceCents < priceCents;

  return (
    <div className="font-medium flex items-center">
      {isDiscounted && (
        <span
          className={cn(
            "mr-[0.5em] text-red-600",
            variant === "lg" && "text-2xl"
          )}
        >
          {formatCAD(discountPriceCents)}
        </span>
      )}
      <span
        className={cn(
          "font-semibold",
          {
            "text-muted-foreground line-through": isDiscounted,
          },
          variant === "lg" && "text-2xl"
        )}
      >
        {formatCAD(priceCents)}
      </span>
      {isDiscounted && variant === "lg" && (
        <Badge variant="destructive" className="ml-2 flex-stretch-0">
          Save {formatCAD(sub(priceCents, discountPriceCents))}
        </Badge>
      )}
    </div>
  );
};
export default PriceWithDiscount;
